import { useCallback, useEffect } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import LogoSection from 'pages/ModalOverViewPageHeaderRevamp/components/LogoSection';
import NavigationBar from 'pages/ModalOverViewPageHeaderRevamp/components/NavigationBar';
import UserActions from 'pages/ModalOverViewPageHeaderRevamp/components/UserActions';
import { getUrlValueFromTab } from 'pages/ModalOverViewPageHeaderRevamp/constants';
import { FetchModelBlocks, getBlocks, setActiveOverviewTab } from 'redux/ModelsSlice';
import { neutral } from 'styles/revampTokens';

import type { TabType } from 'pages/ModalOverViewPageHeaderRevamp/types';

// This is the same header component (with the same NavigationBar, complete
// with its tab-switch animation) used across every other revamp module —
// Dashboard/Dimensions/Blocks revamps all import it from
// ModalOverViewPageHeaderRevamp. Builder mode isn't one of its top-level
// tabs, so activeTab is left blank rather than matching one of them.
const BuilderModeNavHeader = () => {
  const { modelId } = useParams();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const model = useSelector(getBlocks);

  useEffect(() => {
    if (modelId && Number(model?.id) !== Number(modelId)) {
      dispatch(FetchModelBlocks({ modelId: Number(modelId) }));
    }
  }, [dispatch, modelId, model?.id]);

  const handleTabChange = useCallback(
    (tab: TabType) => {
      dispatch(setActiveOverviewTab(tab));
      if (modelId) {
        navigate(`/model/${modelId}/${getUrlValueFromTab(tab)}`);
      }
    },
    [dispatch, modelId, navigate],
  );

  return (
    <Flex
      as='header'
      w='100%'
      px={4}
      py='10px'
      alignItems='center'
      justifyContent='space-between'
      gap={2}
      bg={neutral.surface}
      borderBottom='1px solid'
      borderColor={neutral.border}
    >
      <Box minW={0}>
        <LogoSection modelName={model?.name} modelData={model} />
      </Box>
      <Box display='flex' justifyContent='center'>
        <NavigationBar activeTab={'' as TabType} onTabChange={handleTabChange} />
      </Box>
      <UserActions />
    </Flex>
  );
};

export default BuilderModeNavHeader;
